import { DetailGroupInfo, IDetailGroupInfo, IDetailValue, IGridCanInfo, IRuleParemeters } from 'common/model';
import { IDetailInfoDataHttp } from 'common/model/common.model';

export interface IFamilyDetailSaveRequestHttp {
    detailData: Array<IDetailInfoDataHttp>;
    familyGuid: string;
    evideInputContentFormGuid: string;
    selectedVariantGuid?: string | null;
}

export interface IFamilyFormVariant {
    id: number;
    variantGuid: string;
    title: string;
    description: string;
    sortOrder: number;
    isDefault: boolean;
}

export interface IFamilyStaffs {
    user: IFamilyStaff;
    isSelected: boolean;
}

export interface IFamilyContacts {
    contact: IFamilyContact;
    isSelected: boolean;

    role: string;
    roleComment: string;
    // Quick-link gating: explicit false = the viewer's contact scope doesn't cover this
    // member, render the name as plain text (absent = legacy response, keep linking).
    canViewContact?: boolean;
}

export interface IFamily {
    familyTitle: string;
    familyGuid: string;
}

export interface IFamilyStaff extends IFamilyUser {
    // userTitle: string;
    // userGuid: string;
}

export interface IFamilyContact {
    contactDescription: string;
    contactGuid: string;
    contactSortTitle: string;
    contactTitle: string;
    email: string;
    evideInputContentFormGuid: string;
    phone: string;
    refId: number;
    status: string;

    role: string;
    roleComment: string;
    // Carried down from IFamilyContacts.canViewContact by the profile's flattening map.
    canViewContact?: boolean;
}

export interface IFamilyUser {
    emailAddress: string;
    name: string;
    surname: string;
    imageUrl: string;
    evideLicenseId: number;
    evideProjectId: number;
    userGuid: string;
    id: number;
}

export interface IFamilyDetailResponseHttp {
    projectId: number;
    evideInputContentFormGuid: string;
    familyTitle: string;
    familyDescription: string;
    familyGuid: string;
    reference: number;
    groupInfos: IDetailGroupInfo[];
    detailData: IDetailValue[];
    staffs: IFamilyStaffs[];
    contacts: IFamilyContacts[];
    canInfo: IGridCanInfo;
    ruleParemeters: IRuleParemeters;
    variants?: IFamilyFormVariant[];
    selectedVariantGuid?: string | null;
}

export interface IFamilyDetailInfoRequest {
    projectId: number;
    familyGuid: string;
    dontShowCalculatedField: boolean
}


export class FamilyInfo {

    constructor(
        public readonly familyDetailValue: IDetailValue[],
        public readonly groupInfos: ReadonlyArray<DetailGroupInfo>,
        public readonly familyGuid: string,
        public readonly reference: number,
        public readonly evideInputContentFormGuid: string,
        public readonly projectId: number,
        public readonly familyTitle: string,
        public readonly familyDescription: string,
        public readonly canInfo: IGridCanInfo,
        public readonly staffs: IFamilyStaffs[],
        public readonly contacts: IFamilyContacts[],
        public readonly ruleParemeters: IRuleParemeters
    ) { }

    public static fromJson(data: IFamilyDetailResponseHttp) {
        return {
            familyDetailValue: data.detailData,
            canInfo: data.canInfo,
            familyGuid: data.familyGuid,
            reference: data.reference,
            evideInputContentFormGuid: data.evideInputContentFormGuid,
            projectId: data.projectId,
            familyTitle: data.familyTitle,
            familyDescription: data.familyDescription,
            groupInfos: data.groupInfos.map(item => DetailGroupInfo.fromJson(item, data.ruleParemeters)),
            staffs: data.staffs,
            contacts: data.contacts,
            ruleParemeters: data.ruleParemeters,
            variants: data.variants ?? [],
            selectedVariantGuid: data.selectedVariantGuid ?? null
        }
    }
}

export interface GetFamilyContacts {
    familyGuid: string;
    contactGuid: string;
    contactDescription: string;
    contactTitle: string;
    familyDescription: string;
    isSelected: boolean;
    isActive: boolean;
    groupInfos: IDetailGroupInfo[];
    detailData: IDetailValue[];
    canInfo: IGridCanInfo;
}

export interface AddFamilyStaff {
    projectId: string;
    familyGuid: string;
    staffGuid: string;
}



export interface IPotantialStaffRequest {
    projectId: number;
    familyGuid: string;
    currentStuffGuid: string;
}

export interface IPotantialContactRequest {
    familyGuid: string;
    currentContactGuid: string;
}

export interface IGetAddFamilyMemberDetailInfoResponse {
    projectId: number;
    evideInputContentFormGuid: string;
    groupInfos: any[];
    detailData: any[];
    ruleParemeters?: { [key: string]: string };
}

export interface IAddFamilyMemberRequest {
    familyGuid: string;
    contactGuid: string;
    evideInputContentFormGuid: string;
    detailData: import('common/model').IDetailInfoDataHttp[];
    selectedVariantGuid?: string | null;
}